const slugify = (
  value: string,
  options: { replaceSpacesWith: string } = { replaceSpacesWith: '-' }
): string => {
  return value
    .normalize('NFD') // Normalize the string to remove accents
    .replace(/[\u0300-\u036f]/g, '') // Remove accents
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/\s+/g, options.replaceSpacesWith)
    .trim();
};

export { slugify };
